import { gql } from '@apollo/client/core';

export const FETCH_PARENT_OPEN_JOBS = gql`
  query fetchParentOpenJobs($careTypes: [CareType!]) {
    viewer(kind: PARENT) {
      ... on Parent {
        jobs(jobStatuses: [OPEN], careTypes: $careTypes) {
          edges {
            node {
              id
              title
              careType
            }
          }
        }
      }
    }
  }
`;

export interface JobNode {
  id: string;
  title: string;
  careType: string;
}

export interface JobEdge {
  node: JobNode;
}

export interface ViewerJobs {
  jobs?: {
    edges: JobEdge[];
  };
}
